import { useMutation } from '@tanstack/react-query';
import { HcpActivationApi } from '../../../apis/HcpActivationApi/HcpActivationApi.ts';

export function useSendHcpActivationCode() {
    return useMutation<void, Error, { token: string }>({
        mutationFn: ({ token }) => HcpActivationApi.sendCode(token),
    });
}
